import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LucideAngularModule, LayoutDashboard, SlidersHorizontal, Calendar, CalendarClock, CalendarCheck, History, FileText, Users, Headphones, ListOrdered, BarChart3, Info, Building2, MapPin, Wallet, Handshake, Sparkles, User, Stethoscope, Headset, Shield, UserCog, Monitor, Smartphone, ClipboardList, ClipboardCheck, LogOut, ChevronDown, Palette, Package, CreditCard } from 'lucide-angular';
import { SharedModule } from '../shared/shared.module';
import { AcessoNegadoComponent } from './components/acesso-negado/acesso-negado.component';
import { NavbarLinkComponent } from './components/navbar/navbar-link/navbar-link.component';

import { NavbarComponent } from './components/navbar/navbar.component';
import { ProfileComponent } from './components/navbar/profile/profile.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';

const components = [NavbarComponent, NavbarLinkComponent, ProfileComponent, PagesComponent, SidebarComponent, AcessoNegadoComponent];

@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    LucideAngularModule.pick({
      LayoutDashboard, SlidersHorizontal, Calendar, CalendarClock, CalendarCheck,
      History, FileText, Users, Headphones, ListOrdered, BarChart3, Info,
      Building2, MapPin, Wallet, Handshake, Sparkles, User, Stethoscope,
      Headset, Shield, UserCog, Monitor, Smartphone, ClipboardList, ClipboardCheck, LogOut, ChevronDown, Palette, Package, CreditCard
    })
  ],
  exports: [AcessoNegadoComponent]
})
export class PagesModule {}
